import React from "react";
import styles from "../Assessment_Plans/plans.module.css";
import NoPlans from "../../../assets/icons/NoPlans";

const NoJoinSupport = () => {
  return (
    <>
      <div>
        <div className={styles.plansContainer}>
          <div>
            <NoPlans />
          </div>
          <p>No Data.</p>
        </div>
      </div>
    </>
  );
};

export default NoJoinSupport;
